import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { mockData } from '../../data/mock';
import { trackEvent } from '../../lib/analytics';

const { contact } = mockData;

const PHONES = [
  { label: 'Meena', number: contact.phone.meena, event: 'Meena Phone' },
  { label: 'Neeraj', number: contact.phone.neeraj, event: 'Neeraj Phone' },
  { label: 'Office', number: contact.phone.office, event: 'Office Phone' },
];

const EMAILS = [
  { address: contact.email.meena, event: 'Meena Email' },
  { address: contact.email.neeraj, event: 'Neeraj Email' },
];

export const FooterContact = () => (
  <div>
    <h3 className="text-white font-bold mb-4">Contact Info</h3>
    <ul className="space-y-4 text-sm">
      <li className="flex items-start gap-3">
        <Phone className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          {PHONES.map(({ label, number, event }) => (
            <div key={label}>
              <a
                href={`tel:${number}`}
                onClick={() => trackEvent('phone_click', { event_category: 'Contact', event_label: event })}
                className="hover:text-cyan-400 transition-colors"
              >
                {label}: {number}
              </a>
            </div>
          ))}
        </div>
      </li>
      <li className="flex items-start gap-3">
        <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
        <div className="space-y-1">
          {EMAILS.map(({ address, event }) => (
            <div key={address}>
              <a
                href={`mailto:${address}`}
                onClick={() => trackEvent('email_click', { event_category: 'Contact', event_label: event })}
                className="hover:text-cyan-400 transition-colors break-all"
              >
                {address}
              </a>
            </div>
          ))}
        </div>
      </li>
      <li className="flex items-start gap-3">
        <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
        <span>{contact.address}</span>
      </li>
      <li className="flex items-start gap-3">
        <Clock className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
        <div>
          <div>{contact.hours}</div>
          <div className="text-xs text-gray-400">{contact.workingDays}</div>
        </div>
      </li>
    </ul>
  </div>
);

export default FooterContact;
